// @flow
import {
  PHONE_LENGTH,
  PHONE_REGION,
} from '../settings';
import Avatar from '../../assets/images/avatar.png';

export const getUserImage = (userImage: any, useAvatar: boolean = false): string => {
  if (typeof userImage === 'string') return userImage;
  if (userImage && userImage.url) return userImage.url;
  return useAvatar ? Avatar : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTez7mpG_Lfb01PnEMjHa4gYPOx7iNTab4KKVnVCdNSGpa1O2RJ';
};

type GenSelectorsType = {
  selectors: {},
  stateKey: string,
  excluded?: Array<string>
};

export const phoneIsValid = (phone: string) => RegExp(`([${PHONE_REGION}][.-\\s]?)?\\d{${PHONE_LENGTH}}`).test(phone);

export const arrayReplace = (
  list: Array<mixed>,
  element: any,
  newElement: any,
): Array<mixed> => list.map(e => (e === element ? newElement : e));

export const genSelector = (
  selector: Function,
  stateKey: string,
) => (state: Object, ...args: Array<any>) => selector(state[stateKey], ...args);

export const genSelectors = ({ selectors, stateKey, excluded = [] }: GenSelectorsType) => {
  const wSelectors = {};
  Object.keys(selectors).filter(
    selectorName => selectorName !== 'default'
      && !excluded.includes(selectorName),
  ).forEach((selectorName) => {
    wSelectors[selectorName] = (
      state,
      ...args
    ) => selectors[selectorName](state[stateKey], ...args);
  });

  return wSelectors;
};

export const onEnter = (fn: Function, nfn: Function = _ => _): Function => (e: any) => {
  if (e.key === 'Enter') {
    return fn(e);
  }

  return nfn(e);
};

export function flattenMessages(nestedMessages: Object, prefix: string = '') {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
}

export const checkNestedObject = (object: Object, keyToCheck: String, ...nextLevels) => {
  if (!object) return false;
  if (nextLevels.length === 0 && object.hasOwnProperty(keyToCheck)) return true;
  return checkNestedObject(object[keyToCheck], ...nextLevels);
}



// WEBPACK FOOTER //
// ./src/scripts/utils/index.js